import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ConnectionPositionPair, FlexibleConnectedPositionStrategy, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from 'src/app/services/dialog.service';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';

export interface Variations{
    name:string;
    option_list:VariationsOptions[];
    selected:boolean;
}


export interface VariationsOptions{
    option:string;
    image:VariationsOptionsImages;
}

export interface VariationsOptionsImages{
    image_id:string;
}

export interface ShopeeImages{
  image:SafeUrl, 
  image_id:string
}

@Component({
    selector: 'app-shopee-var-tier',
    templateUrl: './shopee-var-tier.component.html',
    styleUrls: ['./shopee-var-tier.component.scss'],
    standalone: false
})
export class ShopeeVarTierComponent implements OnInit {

  @Output() saving:EventEmitter<boolean> = new EventEmitter();

  selectable = true;
  firstFormGroup:UntypedFormGroup;
  secondFormGroup:UntypedFormGroup;
  formVinculo:UntypedFormGroup;
  buttonList:ButtonList[] = [];
  buttonListImage:ButtonList[] = [];
  canSave = false;
  addOnBlur = true;
  showVariationOptions = false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  isFormGroup: boolean;
  constructor(  private fb:UntypedFormBuilder, 
                private http:HTTPService, 
                private sanitizer:DomSanitizer, 
                private spinner:NgxSpinnerService,
                private snackBar:SnackbarService,
                private dialogService:DialogService,
                private cd:ChangeDetectorRef,
                public dynamicServices:DynamicFormsService,
                public ThemeService:ThemeService,
                @Inject(MAT_DIALOG_DATA) public data, 
                public dialogRef:MatDialogRef<any>,) { }
  
  variations:Variations[] = [];
  selectedVariation:Variations;
  opcao = new UntypedFormControl([]);
  shopeeImages:ShopeeImages[] = []; 
  codeproduct = 1;
  codecompany = 122;
  codeshopee = 2;
  codecontract = 2;
  gridmode = true;
  gridmodeVinculo = true;
  newMode = false;
  

  positionPairs: ConnectionPositionPair[] = [
    {
      offsetX: 9,
      offsetY: 1,
      originX: 'end',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'bottom',
      panelClass: null,
    },
  ];
  

  proximo(){
      if ( this.newMode ){
        this.selectedVariation = {
          name:this.firstFormGroup.get('name').value,
          option_list:[],
          selected:false
        }
      }
      
  }

  transformArray(array:VariationsOptions[]){
      let newArray = array.map(x=>x.option);
      return newArray.join(',');
  }

  hasImage(item:VariationsOptions){
      if ( item.image == null ){
        return false;
      }

      //if ( item.image.image_id == null || item.image.image_id == "[]"){
      if ( item.image.image_id == null || item.image.image_id == ""){
        return false;
      }
      
      //let image:string[] = JSON.parse(item.image.image_id);

      //if (image.length > 0 ){
      if ( item.image.image_id!= null ){
        return true;
      }else{
        return false;
      }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    let newArray = this.shopeeImages.map(a => {return {...{image_id:a.image_id,checked:false}}})

    if (value) {
      this.selectedVariation.option_list.push({option: value, image: {image_id: null} });
    }

    event.chipInput!.clear();
  }

  remove(option: VariationsOptions): void {
    const index = this.selectedVariation.option_list.indexOf(option);

    if (index >= 0) {
      this.selectedVariation.option_list.splice(index, 1);
    }

  }

  ngOnInit(): void {
    if ( this.data instanceof UntypedFormGroup){
        this.isFormGroup = true;
    }else{
        this.isFormGroup = false;
    }
        
    let tierVariation = this.isFormGroup?  this.data.get('TIERVARIATION').value :  this.data[0]['TIERVARIATION'];
    this.codecompany = this.isFormGroup? this.data.get('CODECOMPANY').value :  this.data[0]['CODECOMPANY'];
    this.codeproduct = this.isFormGroup? this.data.get('CODEPRODUCT').value :  this.data[0]['CODEPRODUCT'];
    this.codeshopee = this.isFormGroup? this.data.get('CODESHOPEE').value : this.data[0]['CODESHOPEE'];
    this.codecontract = this.isFormGroup? this.data.get('CODECONTRACT').value :  this.data[0]['CODECONTRACT'];

    // if (this.codeshopee == null){
    //      this.dialogRef.close();
    //      setTimeout(()=>{
    //        throw Error("Para criar estrutra é necessário salvar primeiramento o produto");
    //      },100);  
    //  }


    try{
      if ( this.data != null){
        if ( tierVariation!= null ){
          this.variations = JSON.parse(tierVariation);
        }else{
          this.variations = [];
        } 
      }
    }catch(exception){
      this.variations = [];
    }
    

    
    this.formVinculo = this.fb.group({
        CODEPRODUCT:new UntypedFormControl({value:null,disabled:false},{validators: Validators.required}),
        PRICE:new UntypedFormControl({value:null,disabled:false},{validators: Validators.required}),
        QUANTITY:new UntypedFormControl({value:null,disabled:false},{validators: Validators.required})
    })
    
    this.getAllImages().then((data:Object[])=>{
      
      data.forEach(i=>{
        let objectURL = 'data:image/png;base64,' + i['DATAIMAGE'];
        let ob= {
            image:this.sanitizer.bypassSecurityTrustUrl(objectURL),
            image_id: i['IMAGEID'],
            checked: false
        }
        this.shopeeImages.push(ob);

      })

      if (this.shopeeImages.length == 0){
        this.dialogRef.close();
        setTimeout(()=>{
          throw Error("Para criar estrutra é necessário criar imagens de variação na Shopee.");
        },100);  
      }
      
    }).catch(error=>{
        GlobalErrorHandler.showError(error);
    });


    this.firstFormGroup = this.fb.group({
      name:""
    });
    
    this.secondFormGroup = this.fb.group({
      name:"",
      image:""
    });

    this.buttonList.push(
      /*{
        color:"success",
        description:"Carregar Variações",
        action: ()=>{
            this.showVariationOptions = false;
            setTimeout(()=>{
              this.showVariationOptions = true;
            },100)
        }},*/
      {
      color:"primary",
      description:"Salvar",
      action: ()=>{
          
      }},
      {
        color:"warn",
        description:"Cancelar",
        action: ()=>{
         
        }
      });

    this.buttonListImage.push({
      color:"success",
      description:"OK",
      action: (data)=>{
        this.saveImage(data);
      }
    });
  }

  removeHelpers():Object[]{
      let newVariations = this.variations.map(data=>{return {...{name:data.name, option_list: data.option_list}}})
      
      newVariations.forEach(varition=>{
          varition.option_list.forEach(option=>{
            delete option['hover'];
            /*option.image = option.image.filter(d=>d.checked == true);
            option.image.forEach(i=>{
                delete i['checked'];
            });*/
          })
      })

      return newVariations;
  }

  checkImages(newVariations:Variations){
    
      let noError = true;
      newVariations.option_list.forEach(option=>{
          if ( noError ){
            if ( !option.image.image_id ){
              noError = false;
            }
          }
      });
    return noError;     
  }

  salvar(){ 

    this.spinner.show('left-panel');
    let newVariations = this.removeHelpers();
    
    let toSave = null;
    if ( newVariations.length==0){
      toSave = null;
    }else{
      toSave = JSON.stringify(newVariations)
    }

    if ( this.isFormGroup ){
      this.data.get('TIERVARIATION').setValue(toSave);
      this.spinner.hide('left-panel');
      return;
    }


    let local = {
      entityName: 'Mktpshopee',
      remove:false,
      data: [{
          CODECOMPANY: this.codecompany,
          CODEPRODUCT: this.codeproduct,
          CODESHOPEE: this.codeshopee,
          CODECONTRACT: this.codecontract,
          TIERVARIATION:toSave
      }]
    }

    this.http.post(local,'JsonBrokerServices/save',false,true,true).subscribe(result=>{
        this.snackBar.showSuccess("Estrutura de Variação gravado com sucesso.");
        this.newMode = false;
        this.clearAll();
        this.spinner.hide('left-panel'); 
        if (this.isFormGroup ){
          this.data.get('TIERVARIATION').setValue(toSave);
        }else{
          this.data[0]['TIERVARIATION'] = toSave;
        }
        
        this.cd.markForCheck();
        
    },(error)=>{
        this.spinner.hide('left-panel');
        throw error;
    });
  }


  clearAll(){
      this.selectedVariation = null;
      //this.variations = [];
  }

  finalizar(){
      
      if ( !this.checkImages(this.selectedVariation)){
        throw Error('Não é possível salvar estrutura sem imagem.');
      };

      this.gridmode = true;
      
      if (this.newMode ){
        this.variations.push(this.selectedVariation);
      }else{
        let index = this.variations.findIndex(idx=>idx.name == this.selectedVariation.name);
        this.variations[index] = this.selectedVariation;
      }

      this.salvar();

  }

  saveImage(data){
    
      this.selectedVariation.option_list.filter(data=>data['hover']==true).forEach(to=>{
          to['hover']=false;
      })

      let option:VariationsOptions =  data.item;
      let images:VariationsOptionsImages[] =  data.images;
  }


  

  async getAllImages(){
      this.spinner.show('left-panel');
      return await new Promise((resolve,reject)=>{
        let local = { 
          entityName: 'Mktpshopeeimage',
          showImageData:true,
          showImagaDataBase64:true,
          showPresentation:false,
          showRelationshipData:false,
          showRelationship:false,
          condition: `codecompany=${this.codecompany} and codeproduct=${this.codeproduct} and codeshopee=${this.codeshopee} and status='1' and isnull(imageid,'0') !='0' and imagetype='2'`
        }
    
        this.http.post(local,'JsonBrokerServices/find',false,true,true).subscribe(result=>{
          resolve(result['Mktpshopeeimage'] as Object[]);
        },(error)=>{
            throw error;
        },()=>{
          this.spinner.hide('left-panel');
        });
      })
  }

  clickAction(item:VariationsOptions){
    if ( !item['hover'] ){
        item['hover'] = true;
    }else{
        item['hover'] = false;
    }

    this.selectedVariation.option_list.forEach(data=>{
        if ( data.option != item.option){
            data['hover'] = false;
        }
    })
  }

  selectChk(event,item){
      
  }

  removeItem(){
    if ( this.variations.filter(x=>x.selected==true).length == 0){
      this.snackBar.showError("Nenhuma linha selecionada.");
      return;
    }
    this.dialogService.title='Exclusão';
    this.dialogService.openNewDialog("Deseja remover as opções selecionadas?",(data)=>{
      this.variations = this.variations.filter(x=>x.selected==false);
      this.salvar();      
    })    
  }

  imageAction(option:VariationsOptions,image_id:string){
      
    if ( option.image == null ){
        //option.image.image_id = JSON.stringify([image_id]);
        option.image.image_id = image_id;
        return;
      }

      //if ( option.image.image_id == null || option.image.image_id == "[]"){
    if ( option.image.image_id == null || option.image.image_id == ""){
      //option.image.image_id = JSON.stringify([image_id]);
      option.image.image_id = image_id;
      return;
    }
    
      /*let imagens:string[] = JSON.parse(option.image.image_id);
      
      let index = imagens.findIndex(x=>x == image_id);
      
      if ( index == -1 ){
        imagens.push(image_id);
      }else{
        imagens.splice(index,1);
      }
      option.image.image_id = JSON.stringify(imagens);
      */
      
      if( option.image.image_id == image_id){
        option.image.image_id = null;
      }else{
        option.image.image_id = image_id;
      }
  }

  editarItem(selectedItem:Variations){
    this.canSave = true;
    this.gridmode = false;
    this.selectedVariation = selectedItem;
    this.firstFormGroup.get('name').setValue(this.selectedVariation.name);
    this.firstFormGroup.get('name').disable();
    
    /*this.shopeeImages.forEach(si=>{
      this.selectedVariation.option_list.forEach(o=>{
          if ( o.image.length > 0 ){
              let index = o.image.findIndex(pred=>pred.image_id == si.image_id);
              if ( index > -1){
                o.image[index].checked = true;
              }else{
                //o.image.push({image_id:si.image_id, checked: false});
              }
          }else{
            //o.image.push({image_id:si.image_id, checked: false});
          }
      });
    });*/

  }

  getImageById(option:VariationsOptions,item_id:string){
      if ( option.image == null ){
        return false;
      }

      //if ( option.image.image_id == null || option.image.image_id=="[]" ){
      if ( option.image.image_id == null || option.image.image_id=="" ){
        return false;
      }
      
      //let imagens:string[] = JSON.parse(option.image.image_id);
    
      return option.image.image_id == item_id ? true : false;
      //return imagens.findIndex(i=>i == item_id) > -1 ? true : false;
  }


  addItem(){
    this.canSave = true;
    this.firstFormGroup.get('name').setValue('');
    this.firstFormGroup.get('name').enable();
    this.gridmode = false;
    this.newMode = true;
  }



}
